import { isVoltronEnabled } from 'owa-capabilities-definitions/lib/isVoltronEnabled';
import type { MailboxInfo } from 'owa-client-types';

/**
 * Runtime switch for the native Outlook agent (Path B) routing.
 *
 * The agent iframe is entered ONLY on demand, via the ribbon "Agent Mode" button — which
 * flips this in-memory flag right before it opens the Copilot pane. The `agentModeIframe`
 * flight only controls whether that button is shown (see the ribbon), NOT routing: the
 * regular "Copilot" button always opens BizChat, with no agent fork in its path.
 *
 * A plain module flag (not a Satchel observable) is sufficient: the button sets it BEFORE
 * the pane mounts, so the pane/header/drawer read the current value at mount time. It is
 * cleared when the agent pane closes, so the next "Copilot" open is always BizChat.
 */
let forced = false;

/**
 * Force (true) or clear (false) the native Outlook agent path. Called by the ribbon
 * "Agent Mode" button immediately before opening the Copilot pane, and reset to false when
 * the agent pane closes.
 */
export function setOutlookAgentModeForced(value: boolean): void {
    forced = value;
}

/**
 * Whether the Copilot pane should host the Outlook Copilot SDX. Read by the pane container, pane
 * header, and drawer so the SDX-owns-the-chrome decision stays consistent across all three - the
 * flag was previously spelled out at each site and drifted.
 */
export function isOutlookAgentSdxActive(mailboxInfo: MailboxInfo): boolean {
    return isVoltronEnabled(mailboxInfo);
}

/**
 * Single source of truth for whether the Copilot pane should host the native Outlook agent
 * iframe (Path B): true only while the ribbon "Agent Mode" button has forced it. The pane
 * container, pane header, and drawer header all read this so the agent-owns-the-header
 * chrome stays consistent.
 */
export function isOutlookAgentModeActive(): boolean {
    return forced;
}
